import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
import { limitedFilter } from './filters'
const db = firebaseApp.database()

const rtfbsRef = db.ref('rtfbs')
const draftsRtfbsRef = db.ref('drafts/rtfbs')
const currentDraftsRtfbsRef = (currentUserId) => { return db.ref('drafts/rtfbs/' + currentUserId) }

export const rtfbsModule = {
  namespaced: true,
  state: {
    rtfbs: {},
    draftsRtfbs: {},
    // currentStateObject
    // カレントユーザー用の空オブジェクト
    currentRtfbs: {},
    currentDraftsRtfbs: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    [getterConstants.GET_RTFBS]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_RTFBS')
      bindFirebaseRef('rtfbs', rtfbsRef, { wait: true })
    }),
    [getterConstants.GET_DRAFTS_RTFBS]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_DRAFTS_RTFBS')
      bindFirebaseRef('draftsRtfbs', draftsRtfbsRef, { wait: true })
    }),
    [getterConstants.GET_CURRENT_DRAFTS_RTFBS]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_DRAFTS_RTFBS', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('currentDraftsRtfbs', currentDraftsRtfbsRef(currentUserId), { wait: true })
    }),
    [getterConstants.SET_NEW_FBREQUEST]: firebaseAction((context, value) => {
      console.log(value.itemId)
      if (!value.itemId) {
        const newFbRequestRef = rtfbsRef.push()
        newFbRequestRef.set(value)
      } else {
        const editFbRequestRef = db.ref('rtfbs/').child(value.itemId)
        editFbRequestRef.update(value.item)
      }
    }),
    [getterConstants.SET_LIKES]: firebaseAction((context, value) => {
      const setLikeRef = db.ref(
        'rtfbs/' + value.key + '/likes/' + value.userId
      )
      setLikeRef.set(1)
    }),
    [getterConstants.REMOVE_LIKES]: firebaseAction((context, value) => {
      const removeLikeRef = db.ref(
        'rtfbs/' + value.key + '/likes/' + value.userId
      )
      removeLikeRef.remove()
    }),
    [getterConstants.SET_DRAFTS_RTFBS]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      draftsRtfbsRef.child(currentUserId).remove()
      const setDraftsRtfbsRef = draftsRtfbsRef.child(currentUserId).push()
      setDraftsRtfbsRef.set(value)
    }),
    [getterConstants.REMOVE_DRAFTS_RTFBS]: firebaseAction((context, value) => {
      const removeDraftsRtfbsRef = db.ref('drafts/rtfbs/' + value)
      removeDraftsRtfbsRef.remove()
    })
  },
  getters: {
    getRtfbs: state => state.rtfbs,
    getDraftRtfbs: state => state.draftsRtfbs,
    getCurrentDraftRtfbs: state => state.currentDraftsRtfbs,
    getRtfbsByCurrentId: (state, getters, rootState) => {
      const stateRtfbs = limitedFilter(rootState.currentUserId, rootState.currentUser, state.rtfbs)
      console.log('stateRtfbs', stateRtfbs)
      return stateRtfbs
    },
    getRtfbById: (state, getters, rootState) => (key, isAdmin = false) => {
      return (state.rtfbs || {})[key] || {}
      // const rtfb = (state.rtfbs || {})[key] || {}
      // return (userId && (rtfb.userId !== userId)) ? {} : rtfb
    },
    getRtfbsByUserId: (state, getters, rootState) => (userId, currentUserId, isAdmin, isForceBrowsing) => {
      // const stateRtfbs = limitedFilter(rootState.currentUserId, rootState.currentUser, state.rtfbs)
      // let stateRtfbs = state.rftbs
      // if (stateRtfbs[feedkey].userId === userId) {
      //   rtfbs[rtfb] = stateRtfbs[rtfb]
      // }
      let feedsForShow = []
      if (state.rtfbs) {
        const feeds = state.rtfbs
        console.log('userId', userId)
        console.log('currentUserId', currentUserId)
        if (!!isAdmin || !!isForceBrowsing) {
          if (userId === currentUserId) {
            for (const feedkey in feeds) {
              if (feeds[feedkey].userId === currentUserId) {
                feedsForShow.push({
                  key: feedkey,
                  feed: feeds[feedkey]
                })
              }
            }
          } else {
            for (const feedkey in feeds) {
              if (feeds[feedkey].userId === userId) {
                let keyFlag = false
                if (feeds[feedkey].limitedAccess) {
                  if (!(feeds[feedkey].limitedAccess.limitedUsers && Object.keys(feeds[feedkey].limitedAccess.limitedUsers).includes(currentUserId))) {
                    keyFlag = true
                  }
                  if (rootState.currentUser.groups) {
                    if (feeds[feedkey].limitedAccess.limitedGroups && Object.keys(rootState.currentUser.groups).filter(x => Object.keys(feeds[feedkey].limitedAccess.limitedGroups).includes(x)).length > 0) {
                      keyFlag = true
                    } else if (feeds[feedkey].limitedAccess.limitedGroup && Object.keys(rootState.currentUser.groups).filter(x => x === feeds[feedkey].limitedAccess.limitedGroup).length > 0) {
                      keyFlag = true
                    }
                  }
                  if (keyFlag) {
                    feedsForShow.push({
                      key: feedkey,
                      feed: feeds[feedkey],
                      isForceBrowed: true
                    })
                  } else {
                    feedsForShow.push({
                      key: feedkey,
                      feed: feeds[feedkey]
                    })
                  }
                } else {
                  feedsForShow.push({
                    key: feedkey,
                    feed: feeds[feedkey]
                  })
                }
              }
            }
          }
          return feedsForShow
        }
        if (userId === currentUserId) {
          for (const feedkey in feeds) {
            if (feeds[feedkey].userId === currentUserId) {
              feedsForShow.push({
                key: feedkey,
                feed: feeds[feedkey]
              })
            }
          }
        } else if (userId !== currentUserId) {
          for (const feedkey in feeds) {
            if (feeds[feedkey].userId === userId) {
              let keyFlag = false
              if (feeds[feedkey].limitedAccess) {
                if (!(feeds[feedkey].limitedAccess.limitedUsers && Object.keys(feeds[feedkey].limitedAccess.limitedUsers).includes(currentUserId))) {
                  keyFlag = true
                }
                if (rootState.currentUser.groups) {
                  if (feeds[feedkey].limitedAccess.limitedGroups && Object.keys(rootState.currentUser.groups).filter(x => Object.keys(feeds[feedkey].limitedAccess.limitedGroups).includes(x)).length > 0) {
                    keyFlag = true
                  } else if (feeds[feedkey].limitedAccess.limitedGroup && Object.keys(rootState.currentUser.groups).filter(x => x === feeds[feedkey].limitedAccess.limitedGroup).length > 0) {
                    keyFlag = true
                  }
                }
                if (keyFlag) {
                  feedsForShow.push({
                    key: feedkey,
                    feed: feeds[feedkey],
                    isForceBrowed: true
                  })
                } else {
                  feedsForShow.push({
                    key: feedkey,
                    feed: feeds[feedkey]
                  })
                }
              } else {
                feedsForShow.push({
                  key: feedkey,
                  feed: feeds[feedkey]
                })
              }
            }
          }
          console.log('feedsForShow', feedsForShow)
          return feedsForShow
        }
      }
      console.log('feedsForShow', feedsForShow)
      return feedsForShow
    },
    getIsReadLike: (state, getters, rootState) => (targetOwner, targetItem, likeOwner) => {
      let like
      try {
        like = rootState.readTimes['likes']['rtfbs'][targetOwner][targetItem][likeOwner]
      } catch (e) {
        return false
      }
      return !!like
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/rtfbs.js